/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Lot_List_Filter_ProductInputs */

const vi_product_lot_list_filter_product = /** @type {(inputs: Product_Lot_List_Filter_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sản phẩm`)
};

/**

* @param {Product_Lot_List_Filter_ProductInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_lot_list_filter_product = /** @type {((inputs?: Product_Lot_List_Filter_ProductInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Lot_List_Filter_ProductInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_lot_list_filter_product(inputs)
});